import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/index.css";

import { StoreProvider } from "@/context/StoreContext";
import Layout from "@/components/layout/Layout";

import HomePage from "@/pages/Home";
import ShopPage from "@/pages/Shop";
import ProductDetailPage from "@/pages/ProductDetail";
import ExclusivesPage from "@/pages/Exclusives";
import AboutPage from "@/pages/About";
import ContactPage from "@/pages/Contact";
import CartPage from "@/pages/Cart";
import CheckoutPage from "@/pages/Checkout";
import OrderConfirmationPage from "@/pages/OrderConfirmation";
import CheckoutSuccessPage from "@/pages/CheckoutSuccess";
import WishlistPage from "@/pages/Wishlist";
import RecoverPage from "@/pages/Recover";
import {
  FAQPage,
  SizeGuidePage,
  ShippingPage,
  ReturnsPage,
  TrackOrderPage,
} from "@/pages/Support";

import { AdminAuthProvider } from "@/admin/AdminAuthContext";
import AdminRoute from "@/admin/AdminRoute";
import AdminLayout from "@/admin/AdminLayout";
import AdminLogin from "@/admin/AdminLogin";
import AdminDashboard from "@/admin/AdminDashboard";
import AdminOrders from "@/admin/AdminOrders";
import AdminProducts from "@/admin/AdminProducts";
import AdminInventory from "@/admin/AdminInventory";
import AdminCustomers from "@/admin/AdminCustomers";
import AdminAnalytics from "@/admin/AdminAnalytics";
import AdminSettings from "@/admin/AdminSettings";
import AdminSecurity from "@/admin/AdminSecurity";
import AdminMFAChallenge from "@/admin/AdminMFAChallenge";

const Storefront = () => (
  <StoreProvider>
    <Layout>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/shop" element={<ShopPage />} />
        <Route path="/product/:id" element={<ProductDetailPage />} />
        <Route path="/exclusives" element={<ExclusivesPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/cart" element={<CartPage />} />
        <Route path="/checkout" element={<CheckoutPage />} />
        <Route path="/checkout/success" element={<CheckoutSuccessPage />} />
        <Route path="/order-confirmation/:id" element={<OrderConfirmationPage />} />
        <Route path="/wishlist" element={<WishlistPage />} />
        <Route path="/recover/:token" element={<RecoverPage />} />
        <Route path="/faq" element={<FAQPage />} />
        <Route path="/size-guide" element={<SizeGuidePage />} />
        <Route path="/shipping" element={<ShippingPage />} />
        <Route path="/returns" element={<ReturnsPage />} />
        <Route path="/track-order" element={<TrackOrderPage />} />
        <Route
          path="*"
          element={
            <div className="pt-[140px] pb-20 text-center min-h-[60vh]">
              <h1 className="font-display uppercase text-7xl">404</h1>
              <p className="font-body text-xl mt-4 text-ink/80">
                This page got damaged beyond repair.
              </p>
            </div>
          }
        />
      </Routes>
    </Layout>
  </StoreProvider>
);

const AdminApp = () => (
  <AdminAuthProvider>
    <Routes>
      <Route path="login" element={<AdminLogin />} />
      <Route element={<AdminRoute />}>
        <Route path="mfa-challenge" element={<AdminMFAChallenge />} />
        <Route element={<AdminLayout />}>
          <Route index element={<AdminDashboard />} />
          <Route path="orders" element={<AdminOrders />} />
          <Route path="products" element={<AdminProducts />} />
          <Route path="inventory" element={<AdminInventory />} />
          <Route path="customers" element={<AdminCustomers />} />
          <Route path="analytics" element={<AdminAnalytics />} />
          <Route path="settings" element={<AdminSettings />} />
          <Route path="security" element={<AdminSecurity />} />
        </Route>
      </Route>
    </Routes>
  </AdminAuthProvider>
);

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/admin/*" element={<AdminApp />} />
          <Route path="/*" element={<Storefront />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-center"
        toastOptions={{
          unstyled: true,
          classNames: {
            toast:
              "bg-ink text-cream font-mono text-xs uppercase tracking-widest px-6 py-3 border border-charcoal",
          },
        }}
      />
    </>
  );
}

export default App;
